<template>
    <div class="px-4">
        <DRadio
            v-for="(radio, index) in items"
            :key="`radio-${index}`"
            v-model="selected"
            card
            :native-value="radio.value"
            radio-position="right"
            :disabled="submitting"
            @update:model-value="handleRadioSelected(radio)"
        >
            <template
                v-if="radio.avatar"
                #icon
            >
                <UIAvatar
                    :avatar="radio.avatar"
                    size-override="medium-small"
                />
            </template>
            {{ radio.title }}
            <template
                v-if="radio.subtitle"
                #description
            >
                {{ radio.subtitle }}
            </template>
        </DRadio>
    </div>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import { DRadio } from '@digistorm/spark'
    import UIAvatar from '@/components/ui/UIAvatar.vue'

    const router = useRouter()
    const moduleHelpers = useModuleHelpers()
    const { snackbar } = useSnackbars()

    const props = defineProps({
        config: Object,
    })

    const items = ref(props.config.items)

    const errors = ref({})
    const submitting = ref(false)
    const selected = ref(null)

    const handleRadioSelected = (radio = null) => {
        if (submitting.value) {
            return
        }

        const linkData = {
            link: {
                type: 'api-action',
                url: props.config.data.url,
                payload: {
                    value: radio.value,
                    ...radio.additional_data,
                },
            },
        }

        submitting.value = true

        return moduleHelpers.handleClick(router, linkData)
            .then((appModule) => {
                if (!appModule || !appModule.id) {
                    return
                }
                router.push({ name: 'view', params: { id: appModule.id } })
            })
            .catch((error) => {
                if (error?.response?.status === 422) {
                    errors.value = error.response.data
                    return
                }

                console.error('error', error)
                snackbar({
                    message: 'Error submitting form',
                    type: 'error',
                })
            })
            .finally(() => {
                submitting.value = false
            })
    }

    onMounted(() => {
        selected.value = find(items.value, (radio) => radio.selected).value
        moduleHelpers.setAnalyticsScreenFromConfig(props.config)
    })
</script>
